import { withStyles } from "@material-ui/core";
import { CloseOutlined } from "@material-ui/icons";
import reportConstants from "../constants";
import { DriverAdditionalStopPopup } from "../Gantt/Popups";
import { createGanttStop } from "../Gantt/GanttHelper";
import GanttTooltip from "./GanttTooltip";
const styles = () => ({
  closedIcon: {
    color: '#CF0000',
    cursor: 'pointer'
  },
  tooltipHeaderLabel:{
    color:'#FA5C64'
  }
});

const DispatchCancelIcon = ({ classes, routeData, isGanttGridIcon }) => {
  const taskData = isGanttGridIcon
    ? createGanttStop({
        routeData,
        stopType: reportConstants.REPORT_STOP_TYPES.dispatchCancelStop,
        stopTypeLabel: reportConstants.REPORT_STOP_TYPE_LABEL.dispatchCancelStop
      })
    : null;
  const handleClick = (e) => {
    e.stopPropagation();
  }
  //isGanttGridIcon is used to hide Material UI tooltip on Canceled Dispatch icon when its rendered in Gantt Timeline as we already have tooltips for those rendered by Gantt lib component
  return (
    <GanttTooltip
      disableFocusListener
      placement="top"
      title={
        isGanttGridIcon ? <DriverAdditionalStopPopup task={taskData} isCanceledDispatch /> : ''
      }>
      <CloseOutlined
        className={classes.closedIcon}
        onClick={handleClick}
      />
    </GanttTooltip>
  );
};

export default withStyles(styles)(DispatchCancelIcon);
